<section class="site-stocks">
  <iot-platform-ui-panel [hasButton]="false" [title]="'SITES.STOCKS.PANEL_TITLE' | translate" [withCustomAction]="ofTypeBlyott()" class="mt-4 mb-4">

    <div class="flex flex-row items-center justify-center" panelCustomAction>
      @if (ofTypeBlyott() && canUpdateSite()) {
        <div
          [matTooltip]="'SITES.STOCKS.SYNCHRONIZE' | translate"
          [ngClass]="{ 'app-round-button--rotate': loading() }"
          class="panel-button app-round-button site-stocks__btn-sync"
          matTooltipClass="regular-tooltip"
        >
          <button (click)="onSyncStocks()" mat-icon-button>
            <mat-icon>sync</mat-icon>
          </button>
        </div>
      }
    </div>

    @if (loading()) {
      <div class="flex flex-row items-center justify-center w-full" panelGrid>
        <mat-progress-spinner [diameter]="50" color="accent" mode="indeterminate"></mat-progress-spinner>
      </div>
    } @else if (!hasStocks) {
      <ng-container panelGrid>
        <div class="no-data-message flex flex-row items-center justify-center">
          <p>{{ 'SITES.STOCKS.NO_STOCKS' | translate }}</p>
        </div>
      </ng-container>
    } @else {
      <i4b-table-engine-master-view-engine
        (dispatchMasterViewEngineEvent)="onDispatchMasterViewEngineEvent($event)"
        (pageChange)="onPageChange($event)"
        [data]="stocksAsPlatformResponse()"
        [masterViewType]="{ name: 'site-stocks', isPath: false, useExternalMetadata: false }"
        [useExternalData]="true"
        [userPermissions]="userPermissions()"
        panelGrid
      >
      </i4b-table-engine-master-view-engine>
    }
  </iot-platform-ui-panel>
</section>
